import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

interface ClientesCarouselProps {
    title?: string;
    subtitle?: string;
}

const ClientesCarousel: React.FC<ClientesCarouselProps> = ({
    title = "Nuestros Clientes",
}) => {
    // 👉 Agrupa tus imágenes en arrays de 10 (cada grupo será un slide)
    const slides: string[][] = [
        [
            "/assets/ips/Aguada - santander.png",
            "/assets/ips/albania - santander.png",
            "/assets/ips/bolivar - santander.png",
            "/assets/ips/cepita - santander.png",
            "/assets/ips/chipata - santander.png",
            "/assets/ips/coromoro - santander.png",
            "/assets/ips/elPayon - Santander.png",
            "/assets/ips/encino - Santander.png",
            "/assets/ips/Forian - Santander.png",
            "/assets/ips/guavata - santander.png",
        ],
        [
            "/assets/ips/laBelleza - santander.png",
            "/assets/ips/laPaz - Santander.png",
            "/assets/ips/matanza - santander.png",
            "/assets/ips/suaita - santander.png",
            "/assets/ips/aquitania - boyaca.png",
            "/assets/ips/belen - boyaca.png",
            "/assets/ips/berbeo - boyaca.png",
            "/assets/ips/beteitiva - boyaca.png",
            "/assets/ips/borbur - boyaca.png",
            "/assets/ips/boyaca - boyaca.png",
        ],
        [
            "/assets/ips/campoHermoso - Boyaca.png",
            "/assets/ips/cerinza - boyaca.png",
            "/assets/ips/chiquiza - boyaca.png",
            "/assets/ips/chitaraque - boyaca.png",
            "/assets/ips/chivata - boyaca.png",
            "/assets/ips/cienega - boyaca.png",
            "/assets/ips/combita - boyaca.png",
            "/assets/ips/CONFINES - BOAYCA.png",
            "/assets/ips/coper - boyaca.png",
            "/assets/ips/cubara - boyaca.png",
        ],
        [
            "/assets/ips/campoHermoso - Boyaca.png",
            "/assets/ips/cerinza - boyaca.png",
            "/assets/ips/chiquiza - boyaca.png",
            "/assets/ips/chitaraque - boyaca.png",
            "/assets/ips/chivata - boyaca.png",
            "/assets/ips/cienega - boyaca.png",
            "/assets/ips/combita - boyaca.png",
            "/assets/ips/CONFINES - BOAYCA.png",
            "/assets/ips/coper - boyaca.png",
            "/assets/ips/cubara - boyaca.png",
        ], [
            "/assets/ips/cucaita - boyaca.png",
            "/assets/ips/cuitiva - boyaca.png",
            "/assets/ips/elCocuy - Boyaca.png",
            "/assets/ips/firavitoba - Boyaca.png",
            "/assets/ips/floresta - boyaca.png",
            "/assets/ips/gameza - boyaca.png",
            "/assets/ips/iza - boyaca.png",
            "/assets/ips/jenesano - boyaca.png",
            "/assets/ips/jerico - Boyaca.png",
            "/assets/ips/labranzaGrande - boyaca.png",
        ], [
            "/assets/ips/laCapilla - boyaca.png",
            "/assets/ips/laUvita - boyaca.png",
            "/assets/ips/macanal - boyaca.png",
            "/assets/ips/Mongua - Boyaca.png",
            "/assets/ips/muzo - boyaca.png",
            "/assets/ips/Nobsa - Boyaca.png",
            "/assets/ips/nuevoColon - boyaca.png",
            "/assets/ips/oicata - boyaca.png",
            "/assets/ips/otanche - boyaca.png",
            "/assets/ips/pachavita - boyaca.png"
        ], [
            "/assets/ips/paez - boyaca.png",
            "/assets/ips/pajarito - boyaca.png",
            "/assets/ips/Pauna - boyaca.png",
            "/assets/ips/Paya - Boyaca.png",
            "/assets/ips/pesca - boyaca.png",
            "/assets/ips/pisba - boyaca.png",
            "/assets/ips/quipama - boyaca.png",
            "/assets/ips/ramiriqui - boyaca.png",
            "/assets/ips/Raquira - Boyaca.png",
            "/assets/ips/sachica - boyaca.png",
        ], [
            "/assets/ips/samaca - boyaca.png",
            "/assets/ips/santana - boyaca.png",
            "/assets/ips/santaSofia - Boyaca.png",
            "/assets/ips/siachoque - boyaca.png",
            "/assets/ips/socha - boyaca.png",
            "/assets/ips/socota - boyaca.png",
            "/assets/ips/somondoco - boyaca.png",
            "/assets/ips/sotaquira - boyaca.png",
            "/assets/ips/surata - boyaca.png",
            "/assets/ips/susacon - boyaca.png",
        ], [
            "/assets/ips/sutamarchan - boyaca.png",
            "/assets/ips/tibana - boyaca.png",
            "/assets/ips/tibasosa - boyaca.png",
            "/assets/ips/tinjaca - boyaca.png",
            "/assets/ips/toca - boyaca.png",
            "/assets/ips/Togui - boyaca.png",
            "/assets/ips/topaga - boyaca.png",
            "/assets/ips/tota - boyaca.png",
            "/assets/ips/turmeque - boyaca.png",
            "/assets/ips/tuta - boyaca.png",
        ], [
            "/assets/ips/umbita - boyaca.png",
            "/assets/ips/viracacha - boyaca.png",
            "/assets/ips/morales - Bolivar.png",
            "/assets/ips/Gamarra - Cesar.png",
        ]
    ];

    return (
        <section className="sectionClaro mt-3">
            <div className="text-center sections nameSides">
                <h2 className="fw-bold" style={{
                    fontFamily: "Righteous, sans-serif",
                    fontSize: "4em",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                }}>{title}</h2>
            </div>
            <Swiper
                modules={[Autoplay]}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                
                loop
                className="slideClientes"
            >
                {slides.map((grupo, idx) => (
                    <SwiperSlide key={idx}>
                        <div className="row justify-content-center">
                            {grupo.map((src, i) => (
                                <div
                                    key={i}
                                    className="col-6 col-md-4 col-lg-2 d-flex align-items-center justify-content-center mb-2"
                                >
                                    <img
                                        src={src}
                                        alt={`cliente-${i}`}
                                        className="logo-cliente mx-auto d-block img-fluid grayscale"
                                    />
                                </div>
                            ))}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>


        </section>
    );
};

export default ClientesCarousel;
